module.exports = __webpack_public_path__ + "static/date-modal-695a40c220ac1a28db76c28278db981c.png";